import { FETCH_WASTE_DATA, DELETE_WASTE_DATA, FETCH_WASTE_FAILURE, FETCH_WASTE_SUCCESS } from "./actionTypes"

const initialState = {
  loading: false,
  data: null,
  error: null,
  details: {
    loading: false,
    data: null,
    error: null,
  },
}

const Waste = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WASTE_DATA:
      return { ...state, loading: true, error: null }
    case FETCH_WASTE_SUCCESS:
      return { ...state, loading: false, data: action.payload }
    case FETCH_WASTE_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case DELETE_WASTE_DATA:
      return { ...state, loading: false, data: action.payload }

    default:
      return state
  }
}

export default Waste
